import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'next-i18next';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { useAddNewProductSupplier } from '@/modules/warehouseManagement/shared/apiHooks';
import { Button, InputField } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

interface IFormValues {
  name: string;
}

const CreateSupplier = () => {
  const { t } = useTranslation();

  const { closeModal } = useModal();

  const validationSchema: yup.SchemaOf<IFormValues> = yup.object().shape({
    name: yup
      .string()
      .required(t('this-field-is-required'))
      .max(
        100,
        t('this-field-not-accept-more-than-x-character', { count: 100 })
      ),
  });

  const {
    watch,
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm<IFormValues>({
    resolver: yupResolver(validationSchema),
    mode: 'all',
  });

  const { mutate, isLoading } = useAddNewProductSupplier();

  const onSubmit: SubmitHandler<IFormValues> = (values) => {
    mutate(values, {
      onSuccess: () => closeModal(),
    });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className='mt-16 flex flex-col gap-32'
    >
      <InputField
        id='name'
        {...register('name', {
          setValueAs: (value) => (value?.length ? value : undefined),
        })}
        label={t('supplier-name')}
        placeholder={t('supplier-name')}
        error={!!errors?.name}
        errorMessage={errors.name?.message}
        className='w-full !rounded-xl bg-background-transparent desktop:max-h-56'
        labelClasseName='!text-14'
        borderColor='border-outline-variant'
        textColor='text-text-default'
        width='w-full'
        py='!py-14'
      />
      <Button
        loading={isLoading}
        disabled={!watch() || !isValid}
        size='full'
        className='h-56 !rounded-xl'
        type='submit'
      >
        {t('confirm')}
      </Button>
    </form>
  );
};

export default CreateSupplier;
